import joinUrl from 'url-join';
import ajaxPromise from './AjaxPromises';
import { default as CONFIG, default as globalConfig } from './config';
import { extractZoneFromElement } from './format-helper';
import { generateUrlWithRegion } from './url-utils';

export function generateTrackBody(context: AdContext, body = {}) {
  return {
    apps_publishers: [context.apiKey],
    at: new Date().toISOString(),
    connectivity:
      (window.navigator &&
        window.navigator.connection &&
        window.navigator.connection.type) ||
      'unknown',
    content: body,
    version: window.MRAID_ENV.sdkVersion,
    creative: context.creativeId
  };
}

export function sendTrack(event: string, context: AdContext) {
  ajaxPromise.postJson(
    joinUrl(
      generateUrlWithRegion(CONFIG.WSBACK_URL, context.region),
      '/v1/track'
    ),
    generateTrackBody(context, {
      advert: context.impressionId,
      advertiser: context.advertiserId,
      campaign: context.campaignId,
      event,
      t_u: context.isTemporaryUser,
      creative_id: context.creativeId,
      pg: context.page
    }),
    {
      headers: {
        User: context.userId,
        'Instance-Token': context.userInstanceToken,
        'Device-OS': context.deviceOs
      }
    }
  );
}

export function sendOptinTrack(
  context: AdContext,
  activate: boolean,
  extraContent: AnyObject = {}
) {
  ajaxPromise.postJson(
    joinUrl(CONFIG.PRESAGE_URL, '/v1/presage'),
    generateTrackBody(context, {
      data_active: activate ? 'yes' : 'no',
      ...extraContent
    }),
    {
      headers: {
        Context: `${window.MRAID_ENV.sdkVersion}/${
          context.apiKey
        }/${(window.navigator.userAgent.match(/Android (\d+(?:\.\d+){1,2});/) ||
          [])[1] || 'unknown'}`,
        'Instance-Token': context.userInstanceToken,
        'Device-OS': context.deviceOs,
        User: context.userId
      }
    }
  );
}

export function sendInstallTrack(context: AdContext) {
  sendTrack('completed', context);
}

export function getPercentBetween(a: number, b: number): number {
  return b === 0 ? 0 : Math.round((a / b) * 100);
}

interface ClientClickCoordinates {
  pos?: { x: number; y: number };
  zone?: string;
  interaction?: string;
}

export function getClientClickCoordinates(
  eventType: string,
  event: ClickEvent,
  forceZone: string | null = null
): ClientClickCoordinates {
  if (
    'touches' in event &&
    event.touches &&
    event.touches.length &&
    typeof event.touches[0].clientX !== 'undefined' &&
    typeof event.touches[0].clientY !== 'undefined'
  ) {
    return {
      pos: {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      },
      zone: forceZone || extractZoneFromElement(event.touches[0].target),
      interaction: 'screen_touch'
    };
  } else if (
    'clientX' in event &&
    'clientY' in event &&
    typeof event.clientX !== 'undefined' &&
    typeof event.clientY !== 'undefined'
  ) {
    return {
      pos: {
        x: event.clientX,
        y: event.clientY
      },
      zone: forceZone || extractZoneFromElement(event.target),
      interaction: 'screen_click'
    };
  } else if (forceZone) {
    return {
      zone: forceZone,
      interaction: 'screen_click'
    };
  } else if (eventType === 'interaction') {
    return {
      zone: 'system_button',
      interaction: 'system_button'
    };
  } else {
    return {};
  }
}
